import React from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import Dialog from '@mui/material/Dialog'
import 'moment/locale/es'
import './vistaPrevia.css'
import { PdfFileNP } from './PdfFileNP'

export const VistaPreviaPrintNP = ({ auth, infoEmp, dataPreview, viewOptions, open, setOpen, urlLogo, nombre_columna_dias, infoGeneral }) => {
    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia'
                open={open}
                onClose={() => setOpen(false)}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <PDFViewer>
                    <PdfFileNP
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={dataPreview}
                        viewOptions={viewOptions}
                        urlLogo={urlLogo}
                        nombre_columna_dias={nombre_columna_dias}
                        infoGeneral={infoGeneral}
                    />
                </PDFViewer>
            </Dialog>
        </div >
    );
}